import { Button, Col, Form, Input, Row } from "antd";
import { Formix, FormixItem, useForm, useControl } from "@essenza/react";
import { JobService } from "../service/JobService";
const { TextArea } = Input;

function ContactFormController(c) {
    c.skin = ContactForm;
    c.command = {
        SEND: async (job, { control, data }) => {
            //console.log("SAVE", source);
            let form = control.form("student-form");
            let result = await form.validate();
            console.log("STUDENT FORM VALIDATION", form, result);
            if (result.isValid && result.data.body) {
                const session = c.app.session;
                const info = { idjob: 0, businessname: session.tbusinessname, ecompany: session.temail };
                if (job) {
                    info.idjob = job.id;
                    info.title = job.title;
                }
                c.request(JobService, s => s.message(info, result.data, result.data.body).then(() => c.navigate(-1)));
            } else {
                c.navigate(-1);
            }
        },
    }
}

export function ContactForm({ source, job }) {
    const [control] = useControl(ContactFormController);
    const form = useForm("student-form", source, control);
    return (
        <div className="bg-pri round-sm padding-xl">
            <h4 className="spacing-b28">Informazioni di contatto</h4>

            <Formix control={control} form={form} layout='vertical' className="custom-form ">
                <FormixItem label="E-mail" name="temail">
                    <div className="text-left">{source?.data?.temail}</div>
                </FormixItem>
                <FormixItem label="Telefono" name="tphonenumber">
                    <div className="text-left" >{source?.data?.phone}</div>
                </FormixItem>
                <h4 className="spacing-b28">Oppure invia un messaggio</h4>
                <FormixItem label="Messaggio" name="body">
                    <TextArea rows={10} placeholder="Scrivi qui il tuo messaggio"></TextArea>
                </FormixItem>
            </Formix>
            <Row>
                <Col flex="auto" style={{ textAlign: 'left' }}>
                    <Button onClick={() => control.navigate(-1)} className="secondaryButton">Indietro</Button>
                </Col>
                <Col flex="none">
                    <Button onClick={() => control.execute("SEND", job, source)} className="primaryButton">Invia messaggio</Button>
                </Col>
            </Row>
        </div>
    )
}